import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { setResourceModal } from 'store/reducers/global/global-reducer';
import { setScrollPosition } from 'store/reducers/resources/resources-reducer';

import {
  resolveResourceClickForMode,
  ResourceClickMode,
  shouldUseNativeResourceClick,
} from '../resourceClickBehavior';

interface IResourceClickParams {
  slug: string;
  open_in_modal?: boolean;
  resource_format_name?: string;
  link?: string;
  behavioralAction?: () => void;
  unique_id?: string;
  originScrollPosition?: number;
}

export const useResourceClick = (mode: ResourceClickMode = 'default') => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const handleResourceClick = (
    {
      open_in_modal,
      resource_format_name,
      slug,
      behavioralAction,
      unique_id,
      originScrollPosition,
    }: IResourceClickParams,
    event?: React.MouseEvent<HTMLElement>
  ) => {
    const clickScrollPosition = originScrollPosition ?? window.scrollY;
    if (behavioralAction) behavioralAction();

    const decision = resolveResourceClickForMode(
      {
        open_in_modal,
        resource_format_name,
        slug,
      },
      mode
    );

    if (event && shouldUseNativeResourceClick(event, decision)) return;

    event?.preventDefault();

    switch (decision.type) {
      case 'modal':
        if (location.pathname === '/resources') {
          dispatch(setScrollPosition(clickScrollPosition));
        }

        return dispatch(
          setResourceModal({
            show: true,
            slug,
            unique_id,
            originScrollPosition:
              location.pathname === '/resources' ? clickScrollPosition : undefined,
          })
        );
      case 'detail_new_tab':
        return window.open(decision.href, '_blank', 'noopener,noreferrer');
      case 'detail':
        return history.push(decision.href);
    }
  };

  return handleResourceClick;
};
